import sublimationPrinting from "./templates/sublimation-printing";

export default [
  {
    id: `material`,
    title: `Крой и качество материала`,
    content: {
      description: `<p>Тканевый слюнявчик размером 22,5Х20 см</p><p>Все лучшее – детям! Прикольный слюнявчик с фото - это необычный фотосувенир для малыша и его родителей. Вы можете  купить необычный слюнявчик и сами создать дизайн для него у нас на сайте. Детские слюнявчики тоже могут быть модными!</p>`
    }
  },
  {
    id: `printing`,
    title: `Способ печати`,
    content: {
      printingInfo: `${sublimationPrinting}`
    }
  },
  {
    id: `price`,
    title: `Цены`
  },
  {
    id: `delivery`,
    title: `Доставка и оплата`
  },
  {
    id: `reviews`,
    title: `Отзывы`
  }
];
